// Current Site Types Actions
export const RECEIVE_CURRENT_SITE_TYPE_SUCCESS = 'RECEIVE_CURRENT_SITE_TYPE_SUCCESS'
export const RECEIVE_CURRENT_SITE_TYPE_FAILURE = 'RECEIVE_CURRENT_SITE_TYPE_FAILURE'

export const REQUEST_UPDATE_CURRENT_SITE_TYPE_ACTION = 'REQUEST_UPDATE_CURRENT_SITE_TYPE_ACTION'
export const RECEIVE_UPDATE_CURRENT_SITE_TYPE_SUCCESS = 'RECEIVE_UPDATE_CURRENT_SITE_TYPE_SUCCESS'
export const RECEIVE_UPDATE_CURRENT_SITE_TYPE_FAILURE = 'RECEIVE_UPDATE_CURRENT_SITE_TYPE_FAILURE'
export const CLEAR_CURRENT_SITE_TYPE_ERRORS = 'CLEAR_CURRENT_SITE_TYPE_ERRORS'

// Site Type Actions
export const REQUEST_SITE_TYPES_ACTION = 'REQUEST_SITE_TYPES_ACTION'
export const RECEIVE_SITE_TYPES_SUCCESS = 'RECEIVE_SITE_TYPES_SUCCESS'
export const RECEIVE_SITE_TYPES_FAILURE = 'RECEIVE_SITE_TYPES_FAILURE'
export const CLEAR_SITE_TYPES_ERRORS = 'CLEAR_SITE_TYPES_ERRORS'

export const REQUEST_SITE_TYPE_CREATE_ACTION = 'REQUEST_SITE_TYPE_CREATE_ACTION'
export const RECEIVE_SITE_TYPE_CREATE_SUCCESS = 'RECEIVE_SITE_TYPE_CREATE_SUCCESS'
export const RECEIVE_SITE_TYPE_CREATE_FAILURE = 'RECEIVE_SITE_TYPE_CREATE_FAILURE'
export const CLEAR_SITE_TYPE_CREATE_ERRORS = 'CLEAR_SITE_TYPE_CREATE_ERRORS'

export const REQUEST_SITE_TYPES_DISABLE_ACTION = 'REQUEST_SITE_TYPES_DISABLE_ACTION'
export const RECEIVE_SITE_TYPES_DISABLE_SUCCESS = 'RECEIVE_SITE_TYPES_DISABLE_SUCCESS'
export const RECEIVE_SITE_TYPES_DISABLE_FAILURE = 'RECEIVE_SITE_TYPES_DISABLE_FAILURE'
export const CLEAR_SITE_TYPES_DISABLE_ERRORS = 'CLEAR_SITE_TYPES_DISABLE_ERRORS'

export const REQUEST_SITE_TYPES_ENABLE_ACTION = 'REQUEST_SITE_TYPES_ENABLE_ACTION'
export const RECEIVE_SITE_TYPES_ENABLE_SUCCESS = 'RECEIVE_SITE_TYPES_ENABLE_SUCCESS'
export const RECEIVE_SITE_TYPES_ENABLE_FAILURE = 'RECEIVE_SITE_TYPES_ENABLE_FAILURE'
export const CLEAR_SITE_TYPES_ENABLE_ERRORS = 'CLEAR_SITE_TYPES_ENABLE_ERRORS'
